import React, { useState } from "react";
import { verifyOTP } from "../../services/api";
import { useAuth } from "../../context/AuthContext";
import toast from "react-hot-toast";

const OTPVerify = ({ email, onBack }) => {
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();

  const handleVerify = async () => {
    if (otp.length !== 4) {
      toast.error("Please enter 4-digit OTP");
      return;
    }

    setLoading(true);
    try {
      const response = await verifyOTP(email, otp);
      const { token, user } = response.data;
      login(user, token);
      toast.success("Login successful!");
    } catch (error) {
      toast.error(error.response?.data?.message || "Invalid OTP");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-white flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full">
        <div className="text-center mb-8">
          <h2 className="text-2xl font-bold mb-2" style={{ color: "#0B9444" }}>
            Verify OTP
          </h2>
          <p className="text-gray-600">Enter the OTP sent to {email}</p>
        </div>

        <div className="space-y-4">
          <input
            type="text"
            value={otp}
            onChange={(e) =>
              setOtp(e.target.value.replace(/\D/g, "").slice(0, 4))
            }
            placeholder="Enter 4 digit OTP"
            className="w-full px-4 py-3 border border-gray-300 rounded-lg text-center text-2xl tracking-widest focus:ring-2 focus:ring-green-500 focus:outline-none"
            maxLength="4"
          />

          <button
            onClick={handleVerify}
            disabled={otp.length !== 4 || loading}
            className="w-full py-3 rounded-lg text-white font-semibold disabled:opacity-50 transition"
            style={{ backgroundColor: "#0B9444" }}
          >
            {loading ? "Verifying..." : "Verify & Continue"}
          </button>

          <button
            onClick={onBack}
            className="w-full py-3 text-gray-600 hover:text-gray-800"
          >
            Change Email
          </button>
        </div>
      </div>
    </div>
  );
};

export default OTPVerify;
